import { useDispatch, useSelector } from 'react-redux';
import { useRef } from 'react'
import { Controller } from "react-hook-form";
import Marquee from "react-fast-marquee";
import isEmpty from 'lodash/isEmpty';

import { SelectButton } from 'primereact/selectbutton';
import { FileUpload } from 'primereact/fileupload';
import { classNames } from 'primereact/utils';

import { directionOptions, speedOptions } from "../../../../config/constants"
import { setRssSettings } from '../../../../redux/Slices/Apps/appsSlice';
import { isNull } from 'lodash';
import { getFormErrorMessage } from '../../../../config/global';
import { useTranslation } from 'react-i18next';

const Bar = ({ feeds, preview = false }) => {
  const { rssSettings } = useSelector(state => state.apps);

  return (
    <Marquee
      direction={rssSettings?.direction}
      autoFill={preview ? true : false}
      speed={`${50 * rssSettings?.speed}`}
      style={{
        backgroundColor: `${rssSettings?.bg_color}`,
        color: `${rssSettings?.text_color} !important`,
        fontFamily: rssSettings?.font_family,
        fontSize: `${rssSettings?.font_size}px`
      }}
    >
      {
        feeds.map((item, index) => {
          return (
            <div className={` d-flex align-items-center ${preview ? "" : "py-1 "}`} key={`${Math.random(20)}`}>
              <h4 className='mb-0 ' style={{
                color: rssSettings?.text_color,
                fontFamily: rssSettings?.font_family,
                fontSize: `${preview ? rssSettings?.font_size - 3 : rssSettings?.font_size}px`
              }}>{item?.title}</h4>
              <img src={isEmpty(rssSettings?.newSeparator) ? rssSettings?.separator : URL.createObjectURL(rssSettings?.newSeparator)}
                style={{ width: preview ? '30px' : '40px' }}
                className={`${preview ? "mx-3" : "  mx-5 "}`}
              />
            </div>
          )
        })
      }
    </Marquee >
  )
}

const BottomOption = ({ control, errors, classes = {} }) => {
  const { t } = useTranslation();
  const { rssSettings } = useSelector(state => state.apps);
  const fileUploadRef = useRef(null);
  const dispatch = useDispatch()
  const chooseOptions = {
    className: 'upload_separator',
    label: t('rss.click_to_upload'),
    style: {
      background: 'transparent',
      color: 'gray',
      width: "100%",
      border: "2px dashed #D9DEE3",
      fontWeight: "normal",
      fontSize: classes?.separator && "13px",
      padding: classes?.separator && "5px",

    }
  };

  const onFileSelect = (event) => {
    const file = event.files && event.files[0];

    if (file) {
      dispatch(setRssSettings({ newSeparator: file }))
    }
  };

  const onCancelUpload = () => {
    dispatch(setRssSettings({ newSeparator: null }))

    fileUploadRef.current.clear();
  };

  const handleInput = (inputName, value, field) => {
    if (!isNull(value)) {
      field.onChange(value);
      dispatch(setRssSettings({ [inputName]: value }))
    }
  }
  return (
    <>
      <div className={`col-6 p-1 `}>
        <label htmlFor="direction" className={`mb-0 form-label text-capitalize `} >{t('rss.direction')}</label>
        <Controller name="direction" control={control} className=""
          rules={{ required: false }}
          render={({ field, fieldState }) => (
            <SelectButton
              id={field.name} {...field}
              className={`custom_select d-flex ${classNames({ 'p-invalid': fieldState.invalid })}`}
              inputRef={field.ref}
              onChange={(e) => handleInput("direction", e.value, field)}
              options={directionOptions}
              optionLabel="icon" />
          )} />
      </div>

      <div className={`col-6  p-1 mb-2`} >
        <label htmlFor="speed" className={`mb-0 form-label text-capitalize `} >{t('rss.speed')}</label>
        <Controller name="speed" control={control}
          rules={{ required: false }}
          render={({ field, fieldState }) => (
            <SelectButton
              id={field.name} {...field}
              onChange={(e) => handleInput("speed", e.value, field)}
              className={`custom_select d-flex ${classNames({ 'p-invalid': fieldState.invalid })}`}
              inputRef={field.ref}
              options={speedOptions}
              optionLabel="label"
            />
          )} />
      </div>

      {/* Separator Input */}
      <div className={`col-12 ${classes?.mb ?? "mb-3"} d-flex flex-column`} >
        <label htmlFor="separator" className={`mb-0 form-label text-capitalize `} >{t('rss.separator')}</label>
        <Controller name="separator" control={control}
          rules={{
            required: false,
            validate: (value) => {
              if (!isEmpty(rssSettings?.newSeparator) && rssSettings?.newSeparator?.size > 2000000) return "File size must be less than 2MB";
              return true;
            },
          }}
          render={({ field, fieldState }) => (
            <FileUpload
              mode="basic"
              name="separator"
              accept="image/*"
              maxFileSize={2000000} // 2M
              customUpload
              onSelect={onFileSelect}
              ref={fileUploadRef}
              onClick={onCancelUpload}
              chooseOptions={chooseOptions}
            />
          )} />
        {getFormErrorMessage("separator", errors)}
      </div>
    </>
  )
}

export {
  Bar,
  BottomOption
}